// extracted by mini-css-extract-plugin
module.exports = {"fullScreenWrapper":"GameOverlay_fullScreenWrapper__2kQss","fullScreenBtn":"GameOverlay_fullScreenBtn__2fq0r","soundBtn":"GameOverlay_soundBtn__35z58"};